module.exports = __webpack_public_path__ + "img/2@3x.0fcef14c.png";